import React, { createContext, useContext, useEffect, useState } from "react";
import { usePageContext } from "../Context/PageContextProvider";
export const FinlandBankIDAuthContext = createContext({});
export const useAuth = () => useContext(FinlandBankIDAuthContext);
export const FinlandBankIDAuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const { brand } = usePageContext();
    const getUser = async () => {
        const response = await fetch("/api/account/polestarfi/getUser");
        const json = (await response.json());
        setIsAuthenticated(json.isAuthenticated);
        setIsLoading(false);
    };
    useEffect(() => {
        if (brand == "polestarfi" || brand == "polestarforetagfi") {
            console.log('FI support detected');
            getUser();
        }
    }, []);
    const login = () => {
        window.location.href = "/api/account/polestarfi/signin?returnUrl=" + window.location;
    };
    const logout = () => {
        fetch("/api/account/polestarfi/logout"); // fire and forget for logout call
    };
    return (React.createElement(FinlandBankIDAuthContext.Provider, { value: {
            isAuthenticated,
            isLoading,
            login,
            logout
        } }, children));
};
export default FinlandBankIDAuthProvider;
export const useFinlandBankIDContext = () => {
    const context = React.useContext(FinlandBankIDAuthContext);
    if (context === undefined) {
        throw new Error("use Finland Bank Context should be used inside FinlandBankIDAuthProvider");
    }
    return context;
};
